import { fromPairs, flow, map, toPairs, toUpper, union } from 'lodash/fp';
import { OTHER } from './values';

const SUBTYPE_OTHER = [OTHER, __('search.vehicleOptions.other')];

const toUpperKeys = flow(
  map(([key, value]) => [toUpper(key), value]),
  fromPairs,
);

export const getSubTypeOptions = flow(
  toPairs,
  map(([key, { name, subtypes } = {}]) => {
    subtypes = flow(toPairs, union([SUBTYPE_OTHER]), toUpperKeys)(subtypes);

    return [toUpper(key), { name, subtypes }];
  }),
  fromPairs,
);
